import { UntypedFormGroup } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ChangeDetectorRef, ViewChild, OnInit, Component, Input } from '@angular/core';
import { IRevisionHistory } from '../../shared/models/revisionHistory.model';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-version-modal',
    templateUrl: 'version-modal.component.html',
    standalone: false
})
export class VersionModalComponent implements OnInit {

  @ViewChild('buildModalDialog') buildModalDialog: DialogComponent;
  @Input() revisionHistory: IRevisionHistory = null;
  @Input() formGroup: UntypedFormGroup = null;
  @Input() onStart: Function;
  @Input() onClose: Function;
  @Input() stateFlags: any;

  //Modal for selecting SPL Version
  confirmDialogSelection$: Subject<boolean> = new Subject<boolean>();
  isBuild: boolean;
  invalidSplVersion: boolean;
  updatedSPLVersion: string;
  buildModalDialogVisible: boolean;
  sub: Subscription;
  formData: any;

  // Modal properties
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '30%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;

  constructor(private cdRef: ChangeDetectorRef) {
    this.cdRef = cdRef;
  }

  ngOnInit() {
  }

  splVersionModalOpen() {
    const splInput = document.getElementById('splVersionModalInput');

    if (splInput) {

      if (this.revisionHistory.Revisions && this.revisionHistory.Revisions.length > 0 && this.formGroup && this.formGroup.value) {

        // Default the SPL Version Number to 1 if:
        // this is the first form in its Revision History
        // the formVersion (Major version) is 0
        if (this.revisionHistory.Revisions.length === 1 && this.formGroup.value.formVersion === 0) {
          (splInput as any).value = '1';
        } else {
          (splInput as any).value = `${+this.formGroup.value.splVersion + 1}`;
        }
      }
      this.updatedSPLVersion = (splInput as any).value;
    }
  }

  splVersionModal() {

    //Initial validation
    if (!this.onStart()) {
     return;
    }

    // show modal for setting a version and cancel the build if Cancel is seleced.
    this.buildModalDialog.show();

    this.sub = this.confirmDialogSelection$.subscribe(choice => {

      if (!choice) {

         this.stateFlags.buildLoading = false;
         this.stateFlags.pageLoading = false;
      } else {

        this.formGroup.markAsDirty();

         this.stateFlags.buildLoading = true;
         this.stateFlags.pageLoading = true;

        this.cdRef.detectChanges();

        if (!this.stateFlags.processComplete) {
          this.onClose();
          this.isBuild = true;
          this.stateFlags.processComplete = true;
        }
      }
    });
  }

  buildDlgBtnYes: EmitType<object> = () => {

    if (+this.updatedSPLVersion > 0 || (true && this.updatedSPLVersion === '1')) {

      this.buildModalDialog.hide();

      return this.confirmDialogSelection$.next(true);
    } else {

      this.invalidSplVersion = true;
    }
  }

  buildDlgBtnNo: EmitType<object> = () => {

    this.invalidSplVersion = false;

    const splInput = document.getElementById('splVersionModalInput');

    if (splInput) {
      (splInput as any).value = '';
    }

    this.buildModalDialog.hide();

    return this.confirmDialogSelection$.next(false);
  }

  buildDlgButtons: Object[] = [{ click: this.buildDlgBtnNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.buildDlgBtnYes.bind(this), buttonModel: { content: 'Continue', isPrimary: true } }];

  validateSplVersionInput(event) {

    this.invalidSplVersion = false;

    if (event.target.value) {

      this.updatedSPLVersion = parseInt(event.target.value, 10).toString();
    } else {

      this.updatedSPLVersion = '';
    }
  }
}
